// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
	
	{ label:'姓名:',xs:24,sm:24,md:12,lg:6,xl:6,type:'input',modelValue:'name',op:'selectOptions'},
	{ label:'性别:',xs:24,sm:24,md:12,lg:4,xl:4,type:'select',modelValue:'sex',op:"sexOption"},
	{ label:'年龄:', xs:24,sm:24,md:12,lg:4,xl:4,type:'input',modelValue:'age'},
	{ label:'三无:',xs:24,sm:24,md:12,lg:2,xl:2,type:'checked',modelValue:'thrNot',op:"ObjectsOptions"},
	{ label:'身份证号:',xs:24,sm:24,md:12,lg:8,xl:8,type:'input',modelValue:'certno',op:'selectChanceAll'},
	
	{ label:'出生日期:',    xs:24,sm:24,md:12,lg:6,xl:6,type:'date',iconDialogVisible:true,modelValue:'brdy'},
	{ label:'农历出生日期:',xs:24,sm:24,md:12,lg:6,xl:6,type:'input',modelValue:'lunrBrdy',op:"lunrBrdyOptions"},
	// { label:'生肖:',xs:24,sm:24,md:12,lg:6,xl:6,type:'inputIcon',modelValue:'',suffixIcon:"el-icon-date",disabled:true},
	{ label:'创建方式:',    xs:24,sm:24,md:12,lg:6,xl:6,type:'select',modelValue:'createType',op:'createTypeOption'},
	
	{ label:'国籍:',xs:24,sm:24,md:12,lg:6,xl:6,type:'select',modelValue:'ntlyId',op:"ntlyOptions"},
	{ label:'婚姻状况:',xs:24,sm:24,md:12,lg:6,xl:6,type:'select',modelValue:'mrgState',op:"marryiedOptions"},
	{ label:'民族:',xs:24,sm:24,md:12,lg:6,xl:6,type:'select',modelValue:'naty',op:"natyOptions"},
	{ label:'学历:',xs:24,sm:24,md:12,lg:6,xl:6,type:'select',modelValue:'edulBacdId',op:"edulOptions"},
	
	// { label:'宗教信仰:',xs:24,sm:24,md:12,lg:8,xl:8,type:'input',iconDialogVisible:true,modelValue:'expenseCategoryId',op:'expenseCategoryIdOptions'},
	{ label:'本人电话:',xs:24,sm:24,md:12,lg:8,xl:8,type:'input',modelValue:'tel'},
	{ label:'职业:',xs:24,sm:24,md:12,lg:8,xl:8,type:'select',modelValue:'jobId',op:'jobOptions'},
	
	{ label:'工作地址编码:',xs:24,sm:24,md:12,lg:8,xl:8,type:'input',disabled:true,modelValue:'brdyAddCode'},
	// { label:'工作地址编码:',xs:24,sm:24,md:12,lg:8,xl:8,type:'input',iconDialogVisible:true,modelValue:'emprAddCode'},
	{ label:'ABO血型:',xs:24,sm:24,md:12,lg:8,xl:8,type:'select',modelValue:'aboId',op:'ABOOptions'},
	
	{ label:'Rh血型:',xs:24,sm:24,md:12,lg:8,xl:8,type:'select',modelValue:'aboRhId',op:'RHOptions'},
	
	// { label:'联系人姓名:',xs:24,sm:24,md:12,lg:8,xl:8,type:'input',modelValue:'conerName'},
	// { label:'联系人关系:',xs:24,sm:24,md:12,lg:8,xl:8,type:'input',modelValue:'conerRltsId'},
	// { label:'联系人证件类型:',xs:24,sm:24,md:12,lg:8,xl:8,type:'select',modelValue:'conerCertTypeId',op:"certypeOptions"},
	
	// { label:'联系人证件号:',xs:24,sm:24,md:12,lg:8,xl:8,type:'input',modelValue:'conerCertNo'},
	// { label:'联系人电话:',xs:24,sm:24,md:12,lg:8,xl:8,type:'input',modelValue:'conerTel'},
	
	// { label:'出生地址:',xs:24,sm:24,md:24,lg:24,xl:24,type:'cascader',modelValue:'brdyAddCode'},
	// { label:'工作地址:',xs:24,sm:24,md:24,lg:24,xl:24,type:'cascader',op:'ssqOptions',modelValue:'emprAddCode'},
	// { label:'籍贯地址:',xs:24,sm:24,md:24,lg:24,xl:24,type:'cascader',op:'ssqOptions',modelValue:'naplAddCode'},
	// { label:'户口地址:',xs:24,sm:24,md:24,lg:24,xl:24,type:'cascader',op:'ssqOptions',modelValue:'restAddCode'},
	{ label:'联系地址:',xs:24,sm:24,md:24,lg:24,xl:24,type:'cascader',modelValue:'conerAddCode',op:'conOption'},
	
	// { label:'数据来源:',xs:24,sm:24,md:12,lg:6,xl:8,type:'selected',modelValue:'remake'},
	{ label:'过敏信息表:',xs:24,sm:24,md:12,lg:6,xl:8,type:'table',modelValue:'remake'},
	// { label:'积分人员分类:',xs:24,sm:24,md:24,lg:24,xl:24,type:'select',modelValue:'pointPhrTypeId',op:'pointOption'},
	// { label:'联系地址:',xs:24,sm:24,md:12,lg:4,xl:6,type:'cascader',modelValue:'remake',op:'conOption'},
	// { label:'联系地址:',xs:24,sm:24,md:12,lg:4,xl:6,type:'cascader',modelValue:'remake',op:'conOption'},
	]

